import {addClass, removeClass, toggleClass} from "../_vars";
import Vlitejs from 'vlitejs';
import {disableScroll} from "./disableScroll.js";
import {enableScroll} from "./enableScroll.js";
import LazyLoad from "vanilla-lazyload";

export const resultVideoPlay = () => {
   const resultSection = document.querySelector(".result");
   const resultFull = document.querySelector(".result-full");
   if (!resultFull || !resultSection) return;
   const videoEl = resultFull.querySelector("video");
   const video = new Vlitejs(videoEl, {options: {fullscreen: false}});
   const overlay = resultFull.querySelector(".v-overlay");
   const cursor = document.querySelector(".cursor");
   const cursorText = cursor.querySelector(".cursor__text");

   let isHappening;

   resultSection.addEventListener("click", () => {
      if (isHappening) return;
      isHappening = true;

      disableScroll();
      resultFull.style.display = "flex";
      setTimeout(() => {
         addClass(resultFull, "--full");
         addClass(document.body, "--hidden");
         cursor.classList.remove("--reel-open");
         cursor.classList.add("--reel-close");
         cursorText.textContent = cursorText.getAttribute("data-reel-close");
         setTimeout(() => {
            LazyLoad.load(videoEl, {});
            video.player.play();
            isHappening = false;
         }, 100);
      }, 100)
   });

   overlay.addEventListener("click", () => {
      if (isHappening) return;
      isHappening = true;

      addClass(resultFull, "--close");
      cursor.classList.remove("--reel-close");
      cursor.classList.add("--reel-open");
      cursorText.textContent = cursorText.getAttribute("data-reel-open");
      setTimeout(() => {
         addClass(resultFull, "--opacity");
         video.player.pause();
         setTimeout(() => {
            removeClass(resultFull, "--full");
            removeClass(resultFull, "--opacity");
            removeClass(document.body, "--hidden");
            removeClass(resultFull, "--close");
            resultFull.style.display = "";
            enableScroll();
            isHappening = false;
         }, 1000);
      }, 1000);
   });
};
